import React from 'react';
import cx from 'classnames';

import './index.scss';

interface Props {
    className?: string;
    children: React.ReactNode;
    noPadding?: boolean;
}

const Card: React.FC<Props> = (props) => {
    return (
        <div
            className={cx(
                'card',
                {
                    'no-padding': props.noPadding
                },
                props.className
            )}
        >
            {props.children}
        </div>
    );
};

export default Card;
